var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorDisappoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9277_78586)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_9277_78586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.441175 27.2813C0.441175 12.7016 12.2603 0.882385 26.84 0.882385H29.5947C44.6815 0.882385 56.9118 13.1127 56.9118 28.1995V30.0359C56.9118 45.1227 44.6815 57.353 29.5947 57.353H28.6765C13.0826 57.353 0.441175 44.7116 0.441175 29.1177V27.2813Z",
    fill: "url(#paint0_radial_9277_78586)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9277_78586)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.4025,
    y: 17.1449,
    width: 5.5403,
    height: 7.91471,
    rx: 2.77015,
    fill: "#221725"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_9277_78586)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.9528,
    y: 17.1449,
    width: 5.5403,
    height: 7.91471,
    rx: 2.77015,
    fill: "#221725"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_9277_78586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8952 34.664C20.0421 31.9254 22.5024 29.9576 25.4261 29.4405L26.1079 29.3199C27.8071 29.0194 29.5459 29.0194 31.2451 29.3199L31.9269 29.4405C34.8506 29.9576 37.3109 31.9254 38.4578 34.664C39.2607 36.5811 37.8526 38.6975 35.7741 38.6975H21.5789C19.5004 38.6975 18.0923 36.5811 18.8952 34.664Z",
    fill: "#EE7155"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.1972 15.5085L49.3801 5.74831C50.3084 3.58236 53.379 3.58237 54.3073 5.74832L58.4902 15.5085C60.5352 20.2802 57.0351 25.5882 51.8437 25.5882C46.6523 25.5882 43.1522 20.2802 45.1972 15.5085Z",
    fill: "url(#paint1_linear_9277_78586)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_9277_78586)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.8954,
    cy: 18.29,
    rx: 2.57021,
    ry: 4.76872,
    transform: "rotate(17.6497 54.8954 18.29)",
    fill: "white",
    fillOpacity: 0.84
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_9277_78586",
    x: -2.08393,
    y: 0.882385,
    width: 63.8164,
    height: 60.1435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.83644,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_9277_78586"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.82066,
    dy: 2.98422
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.50933
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.410985 0 0 0 0 0.717273 0 0 0 0 1 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9277_78586"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.52511,
    dy: 3.67289
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.55811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_9277_78586",
    result: "effect2_innerShadow_9277_78586"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9277_78586",
    x: 16.4025,
    y: 17.1449,
    width: 5.5403,
    height: 7.91473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6.07174,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_9277_78586"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.11191,
    dy: -6.33573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3759
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9277_78586"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_9277_78586",
    x: 34.9528,
    y: 17.1449,
    width: 5.54029,
    height: 7.91473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6.07174,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_9277_78586"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.11191,
    dy: -6.33573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3759
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9277_78586"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_9277_78586",
    x: 17.0276,
    y: 29.0945,
    width: 23.2978,
    height: 12.8803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63866
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.819328
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9277_78586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9277_78586",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63866
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.63866
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_9277_78586"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_9277_78586",
    x: 43.7762,
    y: 5.4041,
    width: 22.2383,
    height: 25.7717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13727,
    result: "effect1_foregroundBlur_9277_78586"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9277_78586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4627 4.55527) rotate(86.5167) scale(52.8954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9277_78586",
    x1: 51.8437,
    y1: 0,
    x2: 51.8437,
    y2: 25.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40BAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9277_78586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorDisappoint);
export default __webpack_public_path__ + "static/media/icon_error_disappoint.08b678b48a5c93c376acd900cbfc659c.svg";
export { ForwardRef as ReactComponent };